// Mapping local des form_id renvoyes par l'API configurateur du portail vers
// les URLs locales de meteris.fr.
//
// Sur meteris-pro, /devis-pc est un formulaire universel qui couvre PC fixe ET
// portable (1 seul formulaire pro/B2B). L'imprimante n'a pas de formulaire dedie
// V2 : fallback vers /contact.

export const FORM_URLS = {
  pc_fixe: '/devis-pc',
  pc_portable: '/devis-pc',
  imprimante: '/contact?sujet=depannage-imprimante',
  formation_mcf: 'https://mcf-formation.fr',
};

/**
 * @param {string} formId - identifiant logique renvoye par l'API.
 * @returns {string} URL locale a ouvrir.
 */
export function resolveFormUrl(formId) {
  if (!formId) return '/contact';
  return FORM_URLS[formId] || '/contact';
}
